import { render, staticRenderFns } from "./AddNew.vue?vue&type=template&id=16b20fc2&scoped=true"
import script from "./AddNew.vue?vue&type=script&lang=js"
export * from "./AddNew.vue?vue&type=script&lang=js"
import style0 from "./AddNew.vue?vue&type=style&index=0&id=16b20fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b20fc2",
  null
  
)

export default component.exports